import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTenant } from '@/hooks/use-tenant'
import { tenantQuery } from '@/lib/supabase-tenant'

export function useMarkAllAsRead() {
  const { schemaName } = useTenant()
  const queryClient = useQueryClient()

  return useMutation<void, Error>({
    mutationFn: async () => {
      if (!schemaName) throw new Error('Tenant not available')

      const { error } = await tenantQuery(schemaName)
        .from('notifications')
        .update({ is_read: true, read_at: new Date().toISOString() })
        .eq('is_read', false)

      if (error) throw error
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', schemaName] })
      queryClient.invalidateQueries({ queryKey: ['notifications', 'unread-count', schemaName] })
    },
  })
}
